'use strict';

import React from 'react';
import ExternalIcon from '../Link/ExternalIcon.jsx';
import PlayLinkContainer from '../Link/PlayLinkContainer.jsx';

const deviceData = [
    {
        title: 'Dator',
        link: 'https://kontakt.svt.se/guide/svt-play-webb',
        iconType: 'computer',
    },
    {
        title: 'Mobil & platta',
        link: 'https://kontakt.svt.se/guide/svt-play-mobil-och-surfplattor',
        iconType: 'mobile',
    },
    {
        title: 'TV',
        link: 'https://kontakt.svt.se/guide/svt-play-pa-tv',
        iconType: 'tv',
    },
];

const Icon = ({ iconType }) => {
    let icon = null;

    switch (iconType) {
        case 'computer':
            icon = <div className="play_device__icon svt_icon svt_icon--computer"></div>;
            break;
        case 'mobile':
            icon = (
                <div>
                    <span className="play_device__icon svt_icon svt_icon--mobile"></span>
                    <span className="play_device__icon svt_icon svt_icon--tablet"></span>
                </div>
            );
            break;
        case 'tv':
            icon = <div className="play_device__icon svt_icon svt_icon--tv"></div>;
            break;
    }

    return icon;
};

const Device = ({ title, link, iconType, onDeviceClick = null }) => {
    return (
        <li className="play_device">
            <PlayLinkContainer
                to={link}
                isExternal={true}
                className="play_link-external play_device__link"
                onClick={() => {
                    onDeviceClick && onDeviceClick(title);
                }}
            >
                <Icon iconType={iconType} />
                <div>
                    <ExternalIcon className="play_link-external__icon" aria-hidden="true" isExternal={true}>
                        <span className="play_link-external__target">{title}</span>
                    </ExternalIcon>
                </div>
            </PlayLinkContainer>
        </li>
    );
};

const Devices = ({ onDeviceClick = null }) => {
    return (
        <div className="play_devices">
            <h2 className="play_devices__header">
                <span>Se dina favoritprogram på</span> <span>SVT Play – När och där du vill</span>
            </h2>
            <ul className="play_devices__list">
                {deviceData.map((device) => {
                    return (
                        <Device
                            key={device.title}
                            title={device.title}
                            link={device.link}
                            iconType={device.iconType}
                            onDeviceClick={onDeviceClick}
                        />
                    );
                })}
            </ul>
        </div>
    );
};

export default Devices;
